export const aboutInfo = {
  brandName: '008pg国际',
  founded: '2019',
  headquarters: '新加坡',
  slogan: '安全、稳定、值得信赖的国际平台',
  introduction: [
    '008pg国际是一家专注于为全球用户提供高品质数字娱乐体验的国际化平台。自2019年成立以来，我们始终秉持"用户至上、安全第一"的核心理念，致力于打造行业领先的安全、稳定、便捷的服务平台。',
    '经过多年的技术积累和市场深耕，008pg国际已发展成为覆盖全球80多个国家和地区、服务超过500万用户的国际化平台。我们的团队由来自世界各地的顶尖技术人才组成，在系统架构、安全防护、用户体验等领域拥有深厚的专业积累。',
    '我们深知安全与信任是平台的基石。008pg国际采用国际领先的安全技术体系，包括多重数据加密、实时风险监控、智能风控引擎等，全方位保障用户的信息安全和资金安全。',
  ],
  values: [
    { title: '安全第一', description: '将用户安全置于首位，持续投入安全技术研发，建立多层次安全防护体系。', icon: 'ri-shield-check-line' },
    { title: '用户至上', description: '以用户需求为导向，不断优化产品体验，提供贴心周到的客户服务。', icon: 'ri-user-heart-line' },
    { title: '创新驱动', description: '坚持技术创新，持续迭代产品功能，保持行业领先的技术竞争力。', icon: 'ri-lightbulb-flash-line' },
    { title: '诚信经营', description: '恪守商业道德，坚持透明、公正的运营原则，赢得用户的长期信任。', icon: 'ri-hand-heart-line' },
  ],
  milestones: [
    { year: '2019', event: '008pg国际正式成立，推出首版移动端应用' },
    { year: '2020', event: '用户突破100万，完成首轮重大安全架构升级' },
    { year: '2021', event: '全球化战略启动，进入东南亚及东亚市场' },
    { year: '2022', event: '用户突破300万，覆盖全球50个国家和地区' },
    { year: '2023', event: '推出多项创新功能，获行业多项权威认证' },
    { year: '2024', event: '用户突破500万，覆盖全球80+国家和地区' },
    { year: '2025', event: '完成平台全面升级，推出全新v2.0版本' },
  ],
  certifications: [
    'ISO 27001 信息安全管理体系认证',
    'PCI DSS 支付卡行业数据安全标准认证',
    'GDPR 欧盟通用数据保护条例合规',
    '国际权威第三方安全审计认证',
  ],
  contact: {
    email: 'support@008pg.com',
    phone: '+65 1234 5678',
    address: '新加坡滨海湾金融中心',
    workingHours: '7×24小时全天候服务',
  },
};

export const teamMembers = [
  {
    name: '陈伟明',
    role: '创始人 & CEO',
    description: '拥有15年互联网行业经验，曾任职多家知名科技企业高管。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20business%20portrait%20in%20modern%20office%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20clean%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-ceo&orientation=squarish',
  },
  {
    name: '林雨萱',
    role: '首席技术官 CTO',
    description: '计算机科学博士，前硅谷科技公司高级架构师，专注系统安全与性能优化。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20tech%20executive%20portrait%2C%20modern%20office%20setting%2C%20warm%20natural%20lighting%2C%20confident%20poised%20expression%2C%20clean%20professional%20headshot&width=200&height=200&seq=team-cto&orientation=squarish',
  },
  {
    name: '张浩然',
    role: '首席安全官 CSO',
    description: '网络安全领域资深专家，拥有CISSP、CISM等多项国际安全认证。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20security%20expert%20portrait%2C%20modern%20tech%20office%20background%2C%20warm%20professional%20lighting%2C%20serious%20trustworthy%20expression%2C%20corporate%20headshot&width=200&height=200&seq=team-cso&orientation=squarish',
  },
];